export default {
    starGame: false,
    modeDesain: false,
    focus: '',
    showInfo: true,
    legalMove1: {},
    canMove: [],
    susunanModif: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',//'rnbqkbnr/8/8/8/8/8/8/RNBQKBNR',
    susunan: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
    logMoves: [],
    giliran: 'w',
    lose: false,
    win: false,
    jalanLawan: [],

    allPromot: {},
    pionSelectPromotion: '',
    popupPromosi: false,

    runaway: 'w'
}